import React, { useEffect, useRef, useState } from "react";
import api from "@/lib/api";
import { Users } from "lucide-react";

export default function LiveActivity() {
  const [items, setItems] = useState([]);
  const [idx, setIdx] = useState(0);
  const [show, setShow] = useState(false);
  const timer = useRef(null);

  useEffect(() => {
    api.get("/public/live-activity").then((r) => setItems(r.data.items || [])).catch(() => {});
  }, []);

  useEffect(() => {
    if (!items.length) return;
    const cycle = () => {
      setShow(true);
      setTimeout(() => setShow(false), 4200);
    };
    cycle();
    timer.current = setInterval(() => {
      setIdx((i) => (i + 1) % items.length);
      cycle();
    }, 5200);
    return () => clearInterval(timer.current);
  }, [items]);

  if (!items.length) return null;
  const it = items[idx];
  const ago = 1 + ((idx * 7) % 40);

  return (
    <div className="pointer-events-none fixed bottom-5 left-5 z-[60] hidden sm:block">
      <div
        className={`flex items-center gap-3 rounded-2xl px-4 py-3 text-sm text-white shadow-2xl transition-all duration-500 ${show ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}
        style={{ background: "linear-gradient(135deg, #0A2861, #123C8C)", border: "1px solid rgba(244,196,48,0.35)", minWidth: 280 }}
        data-testid="live-activity-toast"
      >
        <div className="grid h-9 w-9 shrink-0 place-items-center rounded-full text-lg" style={{ background: "rgba(244,196,48,0.15)", border: "1px solid rgba(244,196,48,0.4)" }}>
          {it.flag || <Users size={16} className="text-[var(--gold)]" />}
        </div>
        <div className="leading-tight">
          <p className="font-semibold">
            {it.name}{it.country ? <span className="text-[#D7E2F5]"> · {it.country}</span> : null}
          </p>
          <p className="text-[13px] text-[#D7E2F5]">{it.action} · <span className="text-[var(--gold)]">{ago}m ago</span></p>
        </div>
        <span className="ml-auto flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-wider text-emerald-300">
          <span className="h-2 w-2 animate-pulse rounded-full bg-emerald-400" /> Live
        </span>
      </div>
    </div>
  );
}
